<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h1>Parts Unknown</h1>
</div>
</div>
<h4 class="h1t" style="text-align: center;">An Alex Shanahan Thriller</h4>
<h3 class="h2t" style="text-align: center;"><br/>
    Lynne Heitman</h3>
<div class="figure"></div>
<p class="image"></p>
<h3 class="h3t"></h3>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_title.vue?4a9f446c